import { render, staticRenderFns } from "./SlotsActions.vue?vue&type=template&id=82ded79a&scoped=true&lang=pug"
import script from "./SlotsActions.vue?vue&type=script&lang=js"
export * from "./SlotsActions.vue?vue&type=script&lang=js"
import style0 from "./SlotsActions.vue?vue&type=style&index=0&id=82ded79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ded79a",
  null
  
)

export default component.exports